(function () {
  function init() {
    var modal = document.getElementById('vsm-modal');
    if (!modal) return;

    var closeBtn = document.getElementById('vsm-close');
    var titleSpan = document.getElementById('vsm-product-name');
    var list = document.getElementById('vsm-list');

    function openModal() {
      modal.classList.add('show');
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
    function closeModal() {
      modal.classList.remove('show');
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    function getCart() {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }

    function fetchMetafields(handle) {
      return fetch('/products/' + handle + '?view=vsm-meta')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var match = html.match(/<script[^>]*type="application\/json"[^>]*>([\s\S]*?)<\/script>/);
          if (!match) return {};
          var data = JSON.parse(match[1]);
          return data.variants || {};
        })
        .catch(function () { return {}; });
    }

    function parseWeightInKg(title) {
      if (!title) return null;
      var t = title.toLowerCase().trim();
      var kgMatch = t.match(/([\d.]+)\s*kg/);
      if (kgMatch) return parseFloat(kgMatch[1]);
      var gmMatch = t.match(/([\d.]+)\s*g(?:m|ram)?/);
      if (gmMatch) return parseFloat(gmMatch[1]) / 1000;
      return null;
    }

    function costPerKg(priceCents, title) {
      var kg = parseWeightInKg(title);
      if (!kg || kg <= 0) return null;
      var priceRupees = priceCents / 100;
      return Math.round(priceRupees / kg);
    }

    function populateModal(productData, cart, metafields) {
      titleSpan.textContent = productData.title;
      list.innerHTML = '';

      productData.variants.forEach(function (v) {
        var cartQty = 0;
        if (cart && cart.items) {
          cart.items.forEach(function (item) {
            if (item.variant_id === v.id) {
              cartQty = item.quantity;
            }
          });
        }

        var item = document.createElement('div');
        item.className = 'vsm-item';
        item.dataset.variantId = v.id;

        var imgHtml = '';
        if (v.featured_image && v.featured_image.src) {
          imgHtml = '<img src="' + v.featured_image.src.replace(/(\.\w+)\?/, '$1?width=200&') + '" alt="' + escHtml(v.title) + '" loading="lazy">';
        } else if (productData.featured_image) {
          imgHtml = '<img src="' + productData.featured_image.replace(/(\.\w+)\?/, '$1?width=200&') + '" alt="' + escHtml(v.title) + '" loading="lazy">';
        }

        var priceHtml = '<span class="vsm-price">' + formatMoney(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceHtml = '<span class="vsm-compare">' + formatMoney(v.compare_at_price) + '</span>' + priceHtml;
        }

        var perKg = costPerKg(v.price, v.title);
        var perKgHtml = '';
        if (perKg) {
          perKgHtml = '<div class="vsm-per-unit"><span>(Cost upto \u20B9' + perKg.toLocaleString('en-IN') + '/Kg)</span></div>';
        }

        var bestPriceHtml = '';
        var meta = metafields[String(v.id)];
        if (meta && meta.coupon_best_price) {
          bestPriceHtml = '<div class="vsm-best-price">Best Price \u20B9' + escHtml(meta.coupon_best_price) + ' with coupon</div>';
        }

        var actionHtml = '';
        if (cartQty > 0) {
          actionHtml = buildQtySelector(v.id, cartQty);
        } else {
          actionHtml = buildAddBtn(v.id);
        }

        item.innerHTML =
          '<div class="vsm-img">' + imgHtml + '</div>' +
          '<div class="vsm-info">' +
            '<p class="vsm-name">' + escHtml(v.title) + '</p>' +
            '<div class="vsm-prices">' + priceHtml + perKgHtml + '</div>' +
            bestPriceHtml +
          '</div>' +
          '<div class="vsm-action">' + actionHtml + '</div>';

        list.appendChild(item);
      });

      attachActionListeners();
    }

    function buildAddBtn(variantId) {
      return '<button type="button" class="vsm-add-btn" data-vid="' + variantId + '">' +
        '<span>ADD</span>' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle>' +
          '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>' +
        '</svg>' +
        '<div class="vsm-spinner"></div>' +
      '</button>';
    }

    function buildQtySelector(variantId, qty) {
      return '<div class="vsm-qty" data-vid="' + variantId + '">' +
        '<button type="button" class="vsm-qty-minus" aria-label="Decrease">\u2212</button>' +
        '<span class="vsm-qty-val">' + qty + '</span>' +
        '<button type="button" class="vsm-qty-plus" aria-label="Increase">+</button>' +
      '</div>';
    }

    function attachActionListeners() {
      list.querySelectorAll('.vsm-add-btn').forEach(function (btn) {
        if (!btn._vsmBound) {
          btn._vsmBound = true;
          btn.addEventListener('click', function () { handleAdd(btn); });
        }
      });
      attachQtyListenersAll();
    }

    function attachQtyListenersAll() {
      list.querySelectorAll('.vsm-qty-minus').forEach(function (btn) {
        if (!btn._vsmBound) {
          btn._vsmBound = true;
          btn.addEventListener('click', function () { handleQtyChange(btn, -1); });
        }
      });
      list.querySelectorAll('.vsm-qty-plus').forEach(function (btn) {
        if (!btn._vsmBound) {
          btn._vsmBound = true;
          btn.addEventListener('click', function () { handleQtyChange(btn, 1); });
        }
      });
    }

    function attachQtyListeners(actionDiv) {
      actionDiv.querySelectorAll('.vsm-qty-minus').forEach(function (b) {
        b._vsmBound = true;
        b.addEventListener('click', function () { handleQtyChange(b, -1); });
      });
      actionDiv.querySelectorAll('.vsm-qty-plus').forEach(function (b) {
        b._vsmBound = true;
        b.addEventListener('click', function () { handleQtyChange(b, 1); });
      });
    }

    function handleAdd(btn) {
      var vid = btn.dataset.vid;
      btn.classList.add('loading');
      window.__csmAddingAddons = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Failed');
        return getCart();
      })
      .then(function (cart) {
        window.__csmAddingAddons = false;
        updateCartBubble(cart);
        fireCartUpdated(cart);

        var actualQty = 0;
        cart.items.forEach(function (item) {
          if (item.variant_id === Number(vid)) {
            actualQty = item.quantity;
          }
        });

        var actionDiv = btn.closest('.vsm-action');
        actionDiv.innerHTML = buildQtySelector(vid, actualQty || 1);
        attachQtyListeners(actionDiv);
      })
      .catch(function (err) {
        window.__csmAddingAddons = false;
        btn.classList.remove('loading');
      });
    }

    function handleQtyChange(btn, delta) {
      var qtyWrap = btn.closest('.vsm-qty');
      if (!qtyWrap) return;
      if (qtyWrap.dataset.busy === 'true') return;
      qtyWrap.dataset.busy = 'true';

      var vid = qtyWrap.dataset.vid;
      var valSpan = qtyWrap.querySelector('.vsm-qty-val');
      var current = parseInt(valSpan.textContent, 10);
      var newQty = Math.max(0, current + delta);

      if (newQty > 0) {
        valSpan.textContent = newQty;
      }

      var buttons = qtyWrap.querySelectorAll('button');
      buttons.forEach(function (b) { b.disabled = true; });
      window.__csmAddingAddons = true;

      var updates = {};
      updates[vid] = newQty;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Failed');
        return r.json();
      })
      .then(function (cart) {
        window.__csmAddingAddons = false;
        updateCartBubble(cart);
        fireCartUpdated(cart);

        var actualQty = 0;
        if (cart.items) {
          cart.items.forEach(function (item) {
            if (item.variant_id === Number(vid)) {
              actualQty = item.quantity;
            }
          });
        }

        if (actualQty === 0) {
          var actionDiv = qtyWrap.closest('.vsm-action');
          actionDiv.innerHTML = buildAddBtn(vid);
          actionDiv.querySelector('.vsm-add-btn').addEventListener('click', function () {
            handleAdd(actionDiv.querySelector('.vsm-add-btn'));
          });
        } else {
          valSpan.textContent = actualQty;
          buttons.forEach(function (b) { b.disabled = false; });
        }

        qtyWrap.dataset.busy = 'false';
      })
      .catch(function (err) {
        window.__csmAddingAddons = false;
        valSpan.textContent = current;
        buttons.forEach(function (b) { b.disabled = false; });
        qtyWrap.dataset.busy = 'false';
      });
    }

    function fireCartUpdated(cart) {
      try {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      } catch (e) {}
    }

    function updateCartBubble(cart) {
      var bubbles = document.querySelectorAll('.cart-count-bubble span');
      bubbles.forEach(function (el) { el.textContent = cart.item_count; });
      var bubble = document.querySelector('.cart-count-bubble');
      if (bubble) {
        if (cart.item_count > 0) bubble.classList.remove('hidden');
        else bubble.classList.add('hidden');
      }
    }

    function formatMoney(cents) {
      return '\u20B9' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: cents % 100 === 0 ? 0 : 2 });
    }
    function escHtml(str) {
      var d = document.createElement('div');
      d.textContent = str;
      return d.innerHTML;
    }

    /* ═══════════════════════════════════════════
       INTERCEPT ALL ADD BUTTONS ON COLLECTION/HOME
       — Multi-variant: open modal
       — Single-variant: add silently, no redirect
       ═══════════════════════════════════════════ */
    document.addEventListener('submit', function (e) {
      var form = e.target;

      /* Only intercept product card add forms on collection/home pages */
      if (!form.matches('.product-card__add-wrap form')) return;

      /* Skip if we're on a full product page */
      if (document.querySelector('.product__info-wrapper') || document.querySelector('product-form[data-section-id]')) return;

      /* Always prevent default — no redirects, no cart page, no notification */
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var card = form.closest('li, .product-card, .card-wrapper');
      if (!card) return;

      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      var match = link.href.match(/\/products\/([^?#/]+)/);
      if (!match) return;

      var handle = match[1];
      var addBtn = form.querySelector('.product-card__add-btn');
      if (addBtn) addBtn.classList.add('loading');

      /* Fetch product info */
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {

          if (product.variants.length > 1) {
            /* Multi-variant — open modal */
            return Promise.all([
              fetchMetafields(handle),
              getCart()
            ]).then(function (results) {
              var metafields = results[0];
              var cart = results[1];
              populateModal(product, cart, metafields);
              openModal();
              if (addBtn) addBtn.classList.remove('loading');
            });

          } else {
            /* Single-variant — add silently, just update floating bar */
            var vid = product.variants[0].id;
            window.__csmAddingAddons = true;

            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
            })
            .then(function (r) {
              if (!r.ok) throw new Error('Failed');
              return getCart();
            })
            .then(function (cart) {
              window.__csmAddingAddons = false;
              updateCartBubble(cart);
              fireCartUpdated(cart);
              if (addBtn) addBtn.classList.remove('loading');
            });
          }
        })
        .catch(function (err) {
          window.__csmAddingAddons = false;
          if (addBtn) addBtn.classList.remove('loading');
        });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();